import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _EcmDocument, _QualityInspectionOperation, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_BOOLEAN, MASK_BOOLEAN_ICON } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectLabour } from "../../../ManufacturingStandars/Labour/SelectLabour";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { FileService } from "../../../../../core/services/FileService";
import usePaginator from "../../../../theme/Component/usePaginator";
import { SingPanelEditor } from "../../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { PdfDocuments } from "../../../../documents/PdfDocuments";
import { SelectQualityErrorTypes } from "../../QualityErrors/SelectQualityErrorTypes";
import { SelectQualityErrorDetails } from "../../QualityErrors/QualityErrorDetails/SelectQualityErrorDetails";
import { SelectProductionRoute } from "../../../ProductionRoute/SelectProductionRoute";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";

interface ComponentData {
    isModal?: boolean;
    _ProductionOrder?: any;
    isReport?: boolean
}

interface formData {
    State: number;
    InspectorID: number;
    OperatorID: number;
    FromDate: any;
    UptoDate: any;
    Satisfy: number;
    Route: number;
    Labour: number;
    Error: number;
    TypeError: number;
}

export const QualityInspectionOperation = ({ _ProductionOrder, isModal, isReport }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspectionOperation);
    const paginator = usePaginator();
    const signed = useDataBean(_EcmDocument);

    const [form, setForm] = useState<Partial<formData>>({
        State: 1
    })

    const modal = useModal("", MODAL_LG)
    const modalChange = useModal("", MODAL_SM);
    const modalDocument = useModal("Solicitar flujo de firmas", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);

    useEffect(() => {
        if (_ProductionOrder?.IDProductionOrder) {
            getLista();
        } else if (isReport) {
            getLista()
        }
    }, [_ProductionOrder.IDProductionOrder, paginator.page])

    const getLista = () => {
        let props: any = {
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
        }

        if (form.State) props.State = form.State;
        if (form.InspectorID) props.IDInspector = form.InspectorID;
        if (form.Labour) props.IDLabour = form.Labour;
        if (form.OperatorID) props.IDAccountOperator = form.OperatorID;
        if (form.Satisfy) props.Satisfy = form.Satisfy;
        if (form.Error) props.IDQualityErrorDetails = form.Error;
        if (form.TypeError) props.IDQualityErrorTypes = form.TypeError;

        instance.getQualityInspectionOperationRender(paginator.page, 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);

                resp.List.forEach(item => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    const d = item.DataBeanProperties;
                    d.HoraIncio = `${d.ReviewHour ? `${pad(d.ReviewHour ?? 0)}:${pad(d.ReviewMinutes ?? 0)}` : "N/P"}`;
                    d.EntityError = `${d.IDQualityErrorDetails ? `${d.ErrorDetailCode} - ${d.ErrorDetailName}` : "N/P"}`;
                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            State: 1,
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
            IDEmployee: _single.getAccountID(),
            ReviewDate: _single.getCurrenDate(),
            IDProductionRoute: _ProductionOrder.IDProductionRoute,
            Satisfy: false,
        });
        modal.open("Agregar Inspección de Operación")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDQualityInspectionOperation', visible: true },
        { title: 'Inspector', property: 'AccountInspectorFullName', visible: true },
        { title: 'Fecha de Revisión', property: 'ReviewDate', visible: true },
        { title: 'Hora de Revisión', property: 'HoraIncio', visible: true },
        { title: 'Sección', property: 'DepartmentName', visible: true },
        { title: 'Turno Laboral', property: 'WorkShiftName', visible: true },
        { title: 'Ruta de Producción', property: 'ProductionRouteName', visible: true },
        { title: 'Labor', property: 'LabourName', visible: true },
        { title: '¿Cumple?', property: 'Satisfy', visible: true, mask: MASK_BOOLEAN },
        { title: 'Codigo de Seguimiento', property: 'CodeTracingName', visible: true },
        { title: 'Codigo de Seguimiento', property: 'CodeTracingName', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },
        { title: 'Tipo de Error', property: 'ErrorTypeName', visible: true },
        { title: 'Error', property: 'EntityError', visible: true },
        { title: 'Operador', property: 'AccountOperatorFullName', visible: true },
        { title: 'Usuario', property: 'EmployeeFullName', visible: false },

    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState };


        editaItem(x);
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!isReport), evento: () => { modal.open("Editar Inspección de Operación") } },
            { titulo: 'Solicitar Aprobaciones', icono: 'mdi mdi-signature-text', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && (!isReport) && bean.State == 1, evento: () => { openConfirm("Confirmar Eliminación", () => changeStateItem(3)) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionOperation(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalChange.close();
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDAccountOperator", "Department", "WorkShift", "IDLabour", "CodeTracing", "ReviewMinutes", "ReviewHour", "IDInspector"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const createEcmDocumentForFlowControl = () => {

        const Obs = `Durante la inspección de control de calidad en linea del proceso ${bean.LabourName}, provenientes de la ruta de producción ${bean.ProductionRouteName}, desarrollado por el operador ${bean.AccountOperatorFullName}, ${bean.Satisfy ? "si" : "no"} cumple; Observaciones:${bean.Observation}.`

        signed.instance.createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                if (resp.IDDocument > 0) {
                    signed.instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID()).then(
                        (resp: any) => {
                            toast.success(resp);
                            console.log(resp)
                        }
                    ).catch(
                        err => {
                            toast.error("No se pudo iniciar proceso de firmas")
                        }
                    )
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate })
                } else {
                    toast.error("No se genero documentoa firmar")
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }


    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        let props: any = {
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
        }

        if (form.State) props.State = form.State;
        if (form.InspectorID) props.IDInspector = form.InspectorID;
        if (form.Labour) props.IDLabour = form.Labour;
        if (form.OperatorID) props.IDAccountOperator = form.OperatorID;
        if (form.Satisfy) props.Satisfy = form.Satisfy;


        instance.getQualityInspectionOperationRender(1, 15 * paginator.pages, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                resp.List.forEach(item => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    const d = item.DataBeanProperties;
                    d.HoraIncio = `${d.ReviewHour ? `${pad(d.ReviewHour ?? 0)}:${pad(d.ReviewMinutes ?? 0)}` : "N/P"}`;
                });
                setListaExport(resp.List);
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <InputDate name="" value={form.UptoDate} label="Fecha hasta" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={form.InspectorID} label="Inspector" onChange={(e) => { setForm({ ...form, InspectorID: e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={form.OperatorID} label="Operador" onChange={(e) => { setForm({ ...form, OperatorID: e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <label>Cumplimiento</label>
                    <select value={form.Satisfy} className="form-control" onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, Satisfy: value })
                    }}>
                        <option value="">...</option>
                        <option value="1">Cumple</option>
                        <option value="0">No Cumple</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label>Estado</label>
                    <select value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setForm({ ...form, State: value })
                    }} className="form-select">
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>

                {!_ProductionOrder.IDProductionRoute ?
                    (
                        <div className="col-md-4">
                            <SelectProductionRoute label="Ruta" idSelector={form.Route} onChange={(e) => { setForm({ ...form, Route: e }) }} />
                        </div>
                    )
                    : (
                        <></>
                    )
                }
                {_ProductionOrder.IDProductionRoute || form.Route ?
                    (
                        <div className="col-md-4">
                            <SelectLabour IDProductionRoute={_ProductionOrder.IDProductionRoute ?? form.Route} label="Operación" idSelector={form.Labour} onChange={(e) => { setForm({ ...form, Labour: e }) }} />
                        </div>
                    )
                    : (
                        <></>
                    )
                }

                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-6">
                            <SelectQualityErrorTypes idSelector={form.TypeError} onChange={(e) => { setForm({ ...form, TypeError: e }) }} label="Tipo de Error" />
                        </div>
                        <div className="col-md-6">
                            <SelectQualityErrorDetails idSelector={form.Error} onChange={(e) => { setForm({ ...form, Error: e }) }} idErrorType={form.TypeError} label="Error" />
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        headButtons={buttons()}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Operaciones"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDInspector') ? 'has-error' : ''}`} >Inspector</label>
                                <AccountEditor idAccount={bean.IDInspector} label=" " onChange={(e) => { setBean({ ...bean, IDInspector: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Department') ? 'has-error' : ''}`} >Sección de la Operación</label>
                                <SelectTHConstantsValue label=" " code={903} onChange={(e) => { setBean({ ...bean, Department: e }) }} value={bean.Department} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('WorkShift') ? 'has-error' : ''}`} >Turno de Trabajo</label>
                                <SelectTHConstantsValue label=" " code={904} onChange={(e) => { setBean({ ...bean, WorkShift: e }) }} value={bean.WorkShift} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('ReviewDate') ? 'has-error' : ''}`} >Fecha de Revisión</label>
                                <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('ReviewHour') ? 'has-error' : ''} ${missingFields.includes('ReviewMinutes') ? 'has-error' : ''} `} >Hora de Ejecución de la actividad</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReviewHour ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReviewHour: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.ReviewMinutes ?? ""}
                                            onChange={(e) => setBean({ ...bean, ReviewMinutes: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(12)].map((_, i) => (
                                                <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDLabour') ? 'has-error' : ''}`} >Operación</label>
                                <SelectLabour IDProductionRoute={_ProductionOrder.IDProductionRoute} label=" " idSelector={bean.IDLabour} onChange={(e) => { setBean({ ...bean, IDLabour: e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NoPartsChecked') ? 'has-error' : ''}`} >No. Piezas Revisadas</label>
                                <input type="number" value={bean.NoPartsChecked} onChange={(e) => { setBean({ ...bean, NoPartsChecked: e.target.value ? Number(e.target.value) : null }) }} className="form-control" />
                            </div>

                            <div className="col-md-6">
                                <BasicSwitch estado={bean.Satisfy} eventChange={(e) => { setBean({ ...bean, Satisfy: e }) }} label="¿Cumple?" />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('CodeTracing') ? 'has-error' : ''}`} >Código de Seguimiento</label>
                                <SelectTHConstantsValue label=" " code={905} onChange={(e) => { setBean({ ...bean, CodeTracing: e }) }} value={bean.CodeTracing} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDAccountOperator') ? 'has-error' : ''}`} >Operador</label>
                                <AccountEditor idAccount={bean.IDAccountOperator} label=" " onChange={(e) => { setBean({ ...bean, IDAccountOperator: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <SelectQualityErrorTypes idSelector={bean.IDQualityErrorTypes} onChange={(e) => { setBean({ ...bean, IDQualityErrorTypes: e }) }} label="Tipo de Error" />
                                    </div>
                                    {bean.IDQualityErrorTypes &&
                                        <div className="col-md-6">
                                            <SelectQualityErrorDetails idSelector={bean.IDQualityErrorDetails} onChange={(e) => { setBean({ ...bean, IDQualityErrorDetails: e }) }} idErrorType={bean.IDQualityErrorTypes} label="Error" />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Observation') ? 'has-error' : ''}`} >Observación/Recomendaciones</label>
                                <textarea value={bean.Observation} onChange={(e) => { setBean({ ...bean, Observation: e.target.value }) }} className="form-control" />
                            </div>


                        </div>
                    </Modal>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                            <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />
                        </div>
                    </Modal>

                    <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                        <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Calidad - Procedimientos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}